export default class ThankScreenVariation {
  static get ComingSoon() {
    return this.getInstance('comingSoon');
  }

  static get AskQuestion() {
    return this.getInstance('askQuestion');
  }

  static get Brochure() {
    return this.getInstance('brochure');
  }

  static get Tour() {
    return this.getInstance('tour');
  }

  static get Basic() {
    return this.getInstance('basic');
  }

  static fromKey(key) {
    const statusMap = {
      comingSoon: ThankScreenVariation.ComingSoon,
      askQuestion: ThankScreenVariation.AskQuestion,
      brochure: ThankScreenVariation.Brochure,
      tour: ThankScreenVariation.Tour,
      basic: ThankScreenVariation.Basic,
    };

    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ThankScreenVariation(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ThankScreenVariation, 'instances', { value: {} });
